<template lang="pug">
  .b2b-page-newuserexistpermissions
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('users.createuser.profilesuser.title', { username: this.modifyUserSession.username } ) }}
          //- Tabla de Perfiles/Permisos de Usuario
      ods-row(v-if='optionsUserEntitiesRolesAuthorities.length > 2')
        ods-col(:span='24')
          ods-form
            ods-form-item
              ods-select(
                v-model='projectSelectedRolesAuthorities',
                filterable,
                @change='changeProjectSelected()')
                ods-option(
                  v-for='option in optionsUserEntitiesRolesAuthorities',
                  :key='option.projectId',
                  :label='option.projectName',
                  :value='option.projectId')
      ods-row
        ods-col(:span='8', style='text-align: center')
          span {{ $t('user_detail.roles') }}
        ods-col(:span='16', style='text-align: center')
          span {{ $t('user_detail.authorities') }}
      ods-row.profiles
        ods-col(:span='8')
          ods-scrollbar(wrapClass="wrap-styles")
            div(@click='handleChargeAuthoritiesByRole(role)',
                v-for='role in userRolesAuthorities.roles',
                :key='role.id')
              ods-module.box-role(v-bind:class='{active: role == currentRole}')
                ods-checkbox(
                  :disabled='isDuplication',
                  :label='role.roleName',
                  v-model='role.enabled')
                ods-button(
                  icon='ods-icon-chevron-right',
                  style='float:right',
                  type='neutral')

        ods-col(:span='16')
          template(v-if='isNewRole')
            ods-scrollbar(wrapClass="wrap-styles")
              ods-module.box-authority(
                v-for='authority in userRolesAuthorities.authorities',
                :key='authority.id')
                ods-checkbox(
                  :label='authority.name',
                  :checked='authority.enabled')
          template(v-else)
            ods-scrollbar(wrapClass="wrap-styles")
              ods-module.box-authority(
                v-for='autho in authoritiesByRol',
                :key='autho.id')
                template(slot-scope='scope')
                  span {{ getDescriptionAuthority(autho.name) }}
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("user_detail.save_roles_authorities_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            @click='createUpdateUser')
            | {{ $t('user_detail.save_roles_authorities') }}
        ods-tooltip(:content='$t("user_detail.cancel_roles_authorities_tooltip")', placement='bottom')
          ods-button(
            ref='buttonCancel',
            type='neutral',
            @click='cancelChangeRoleAuthorities')
            | {{ $t('user_detail.cancel_roles_authorities') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-newuserexistpermissions',
  mixins: [Utils],
  data () {
    return {
      userId: '',
      // PERFILES Y PERMISOS
      projectSelectedRolesAuthorities: null,
      optionsUserEntitiesRolesAuthorities: [
        {
          projectId: null,
          projectName: this.$t(
            'user_detail.option_all_project_roles_authorities'
          )
        }
      ],
      userRolesAuthorities: [],
      currentRole: {},
      authoritiesByRol: [],
      isNewRole: false,
      isDuplication: false,
      currentProjectId: null,
      selectedRoles: []
    }
  },

  props: {
    duplicateUserData: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'modifyUserSession',
      'urlIn'
    ])
  },

  methods: {
    ...mapActions([
      'getUserRolesAuthorities',
      'getAuthoritiesByRol',
      'saveUpdateUser',
      'getOptionsService',
      'getUserRoles'
    ]),

    getDescriptionAuthority: function (name) {
      return this.$t('authorities.' + name)
    },

    async handleChargeAuthoritiesByRole (role) {
      this.currentRole = role
      const dataQuery = {
        id: role.id
      }
      try {
        const response = await this.getAuthoritiesByRol(dataQuery)
        this.authoritiesByRol = response.content
        // - this.isNewProfile = false
      } catch (error) {
        console.log('handleChargeAuthoritiesByRole CATCH:: ' + error)
        this.getNotificationErrorMessage(error)
      }
    },

    async changeProjectSelected () {
      await this.saveSelectedRoles() // guardamos roles seleccionados antes de cambiar de proyecto
      await this.getUserRolesAuthoritiesOnDatabase()
      await this.loadEnabledRoles() // recuperamos roles seleccionados tras cambiar de proyecto en el select
      for (let index = 0; index < this.selectedRoles.length; index++) {
        const element = this.selectedRoles[index]
        console.log('selectedRoles[' + index + '] = rolId: ' + element.id + ', projectId: ' + element.projectId)
      }
    },

    async saveSelectedRoles () {
      const findRole = (rol) => this.selectedRoles.find(item => item.id === rol.id)
      for (const rol of this.userRolesAuthorities.roles) {
        if (rol.enabled) {
          const existElement = findRole(rol)
          if (!existElement) {
            this.selectedRoles.push({ id: rol.id, projectId: this.currentProjectId })
          }
        } else { // elimino
          for (let index = 0; index < this.selectedRoles.length; index++) {
            const element = this.selectedRoles[index]
            if (element.id === rol.id) {
              this.selectedRoles.splice(index, 1)
              console.log('Eliminado rolId: ' + element.id + ', projectId: ' + element.projectId)
            }
          }
        }
      }
      console.log('selectedRoles.length: ' + this.selectedRoles.length)
      this.currentProjectId = this.projectSelectedRolesAuthorities // actualizamos
    },

    async loadEnabledRoles () {
      let primeraVez = false
      const projectViwed = this.optionsUserEntitiesRolesAuthorities.find(item => item.projectId === this.projectSelectedRolesAuthorities)
      if (projectViwed && !projectViwed.viewed) {
        // Si es la primera visualización del proyecto hay que marcar con check los roles obtenidos de BBDD y no solo los seleccionados
        projectViwed.viewed = true
        primeraVez = true
      }
      const findRole = (rol) => this.selectedRoles.find(item => item.id === rol.id)
      for (const rol of this.userRolesAuthorities.roles) {
        const existElement = findRole(rol)
        if (existElement && existElement.id === rol.id) {
          rol.enabled = true
        } else if (!primeraVez) {
          rol.enabled = false
        }
      }
    },

    async createUpdateUser () {
      await this.saveSelectedRoles() // guardamos los perfiles actualizados por última vez antes de guardar
      const load = this.$loading({
        lock: true,
        text: this.$t('user_detail.load.change_roles_user')
      })
      try {
        // Tenemos que obtener el array id de roles y de authorities que esten seleccionados
        const roles = []
        const authorities = []
        if (!this.isDuplication) {
          if (this.duplicateUserData !== undefined && this.duplicateUserData.rolesAuthoritiesUser !== undefined) {
            for (const rol of this.duplicateUserData.rolesAuthoritiesUser.roles) {
              if (rol.enabled) {
                roles.push({ id: rol.id, idProject: rol.idProject })
              }
            }
          } else {
            /* for (const rol of this.userRolesAuthorities.roles) {
              if (rol.enabled) {
                roles.push({ id: rol.id })
              }
            } */
            const rolesPorProject = {} // objeto para clasificar la información por projectId
            this.selectedRoles.forEach(rol => { // Recorrer el array selectedRoles y clasificar la información
              if (!rolesPorProject[rol.projectId]) {
                rolesPorProject[rol.projectId] = []
              }
              rolesPorProject[rol.projectId].push({ id: rol.id, idProject: rol.projectId })
              roles.push({ id: rol.id, idProject: rol.projectId })
              console.log('projectId:: ' + rol.projectId + ' - rolId:: ' + rol.id)
            })
            // Si alguno de los proyectos no tiene roles seleccionados, hay que recuperar los roles que ya tenía el usuario:
            await Promise.all(this.optionsUserEntitiesRolesAuthorities.map(async project => {
              if (!project.viewed && project.projectId !== null && !rolesPorProject[project.projectId]) {
                this.projectSelectedRolesAuthorities = project.projectId
                await this.getUserRolesAuthoritiesOnDatabase() // recuperamos los roles de BBDD
                const rolesPorProject = this.userRolesAuthorities.roles.filter(rol => rol.enabled && rol.idProject === project.projectId)
                rolesPorProject.forEach(rol => {
                  roles.push({ id: rol.id, idProject: rol.idProject })
                })
              }
            }))
            console.log('rolesPorProject', roles)
          }
        }
        let duplicated = false
        if (this.isDuplication && roles.length === 0) {
          const dataQuery = { userId: this.userId }
          try {
            const userRoles = await this.getUserRoles(dataQuery)
            console.log('userRoles: ', userRoles)
            for (const rol of userRoles.roles) {
              if (rol.enabled) {
                roles.push({ id: rol.id, idProject: rol.idProject })
              }
            }
            duplicated = true
          } catch (error) {
            console.log('getUserRoles: ', error)
            this.getNotificationErrorMessage(error)
          }
        }
        this.modifyUserSession.rolesAuthoritiesUser = {
          roles: roles,
          authorities: authorities,
          projectId: null // this.projectSelectedRolesAuthorities
        }
        // -Guardamos
        if (this.duplicateUserData !== undefined) {
          this.duplicateUserData.rolesAuthoritiesUser.roles = roles // eslint-disable-line
          this.duplicateUserData.rolesAuthoritiesUser.authorities = authorities // eslint-disable-line
          this.duplicateUserData.rolesAuthoritiesUser.projectId = this.projectSelectedRolesAuthorities // eslint-disable-line
          this.duplicateUserData.rolesAuthoritiesUser.duplicated = duplicated // eslint-disable-line
          await this.saveUpdateUser(this.duplicateUserData)
        } else {
          console.log('OBJECT SESSION)', this.modifyUserSession)
          await this.saveUpdateUser(this.modifyUserSession)
        }
        this.$notify({
          title: this.$t('users.createuser.newuser.success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        // Redirigimos a listado de usuarios
        router.push({ name: 'usuarios-table' })
      } catch (error) {
        console.log('createUpdateUser CATCH: ' + error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async cancelChangeRoleAuthorities () {
      await this.getUserRolesAuthoritiesOnDatabase()
    },

    async loadInitial () {
      const dataQueryService = {
        page: 0,
        size: 1000,
        sort: 'name,ASC'
      }
      const proyectos = await this.getOptionsService(dataQueryService)

      this.optionsUserEntitiesRolesAuthorities = [{
        projectId: null,
        projectName: this.$t('user_detail.dialog_add_user_entity.option_all_project')
      }]
      this.projectSelectedRolesAuthorities = null
      // Si es superadmin se deben sacar todos los proyectos
      if (this.modifyUserSession.userentities !== null && this.modifyUserSession.userentities.length === 1 && this.modifyUserSession.userentities[0].projectId === null) {
        // Añadimos los proyectos
        for (const obj of proyectos) {
          const aux = {
            projectId: obj.id,
            projectName: obj.name,
            viewed: false
          }
          this.optionsUserEntitiesRolesAuthorities.push(aux)
        }
      }

      for (const entity of this.modifyUserSession.userentities) {
        // Añadimos las entidades NO REPETIDAS en el array de opciones del select de proyectos y perfiles
        if (!this.optionsUserEntitiesRolesAuthorities.some(this.filterItems(entity))) {
          this.optionsUserEntitiesRolesAuthorities = this.optionsUserEntitiesRolesAuthorities.concat(entity)
        }

        // Si el array de opciones de proyecto tiene dos componentes, quiere decir
        // que en realidad solo tiene 1 proyecto asociado, asi que lo seleccionamos
        if (this.optionsUserEntitiesRolesAuthorities.length === 2) {
          this.projectSelectedRolesAuthorities = this.optionsUserEntitiesRolesAuthorities[1].projectId
        }
      }
      this.currentProjectId = this.projectSelectedRolesAuthorities
      const projectViwed = this.optionsUserEntitiesRolesAuthorities.find(item => item.projectId === this.projectSelectedRolesAuthorities)
      if (projectViwed && !projectViwed.viewed) {
        // Primera visualización del proyecto
        projectViwed.viewed = true
      }
      console.log(this.optionsUserEntitiesRolesAuthorities)
    },

    filterItems (entity) {
      return item => item.projectId === entity.projectId
    },

    async getUserRolesAuthoritiesOnDatabase () {
      console.log(this.projectSelectedRolesAuthorities)
      const dataQuery = {
        userId: this.userId,
        query: {
          projectId: this.projectSelectedRolesAuthorities
        }
      }
      try {
        this.userRolesAuthorities = await this.getUserRolesAuthorities(dataQuery)
      } catch (error) {
        console.log('getUserRolesAuthoritiesOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    console.log('B2bnewuserexistpermissions', this.modifyUserSession.usuario)
    if (this.duplicateUserData !== undefined && this.duplicateUserData.rolesAuthoritiesUser !== undefined) {
      this.isDuplication = true
      this.userId = this.duplicateUserData.userId
      this.modifyUserSession.userentities = this.duplicateUserData.userentities
      console.log('duplicateUserData', this.duplicateUserData)
    } else {
      this.userId = this.modifyUserSession.usuario.id
    }
    await this.loadInitial()
    await this.getUserRolesAuthoritiesOnDatabase()
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-newuserexistpermissions {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }

  .div-role{
    height: 400px;
    overflow-y: auto;
  }

  .box-role{
    margin: 0rem;
  }

  ::v-deep .profiles{
    .wrap-styles {
      height: rem(400);
      border-radius: rem(8);
    }

    .ods-module{
      &__body{
        padding: 20px;
      }
    }
    .active{
      background-color: var(--color-bg-interactive);

      .ods-checkbox{
        .ods-checkbox__label {
          color: var(--color-bg-primary);
        }
        color: var(--color-bg-primary);
      }
      .ods-button{
        color: var(--color-bg-primary);
      }
    }
  }

  .div-authority{
    height: 400px;
    overflow-y: auto;
  }

  .box-authority{
    margin: 0rem;
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

}
</style>
